import {
  catchError,
  combineLatest,
  filter,
  first,
  map,
  Observable,
  of,
  switchMap,
} from 'rxjs';

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthFacade } from '@ideapa/app-auth';

import { CheckBilanciFacade } from '../+state/check-bilanci.facade';

@Injectable()
export class CheckChiusuraEsercizioGuard implements CanActivate {
  constructor(
    private facade: CheckBilanciFacade,
    private authFacade: AuthFacade
  ) {}
  canActivate(): Observable<boolean> {
    return this.checkLoaded().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkLoaded(): Observable<boolean> {
    return combineLatest([
      this.facade.esercizioChecked$,
      this.facade.esercizioEnteId$,
      this.facade.esercizioAnno$,
      this.authFacade.ente$,
      this.authFacade.anno$,
    ]).pipe(
      map(([loaded, enteId, anno, loggedEnte, loggedAnno]) => {
        if (!loaded || enteId !== loggedEnte?.id || anno !== loggedAnno) {
          this.facade.checkEsercizioChiuso();
        }
        return loaded;
      }),
      filter((loaded) => loaded),
      first()
    );
  }
}
